<template>
  <div class="ds-search-panel">
    <div class="ds-search-panel__body">
      <slot name="default"></slot>
    </div>
    <div class="ds-search-panel__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
/**
 * DsSearchPanel —— 筛选条件容器
 *
 * 纯布局组件：**不接管查询逻辑**，字段、栅格、按钮事件仍由使用方控制，
 * 以保证迁移过程中行为与改造前完全一致。
 *
 * Slots:
 *  - default   筛选字段区（建议使用 el-row :gutter="16" + el-col :span="6"）
 *  - actions   操作按钮区（查询 / 重置 / 展开更多）
 */
export default {
  name: 'DsSearchPanel'
}
</script>

<style lang="scss" scoped>
.ds-search-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  padding: var(--ds-spacing-md) var(--ds-spacing-lg);
  margin-bottom: var(--ds-spacing-md);

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ds-spacing-md);
  flex-wrap: wrap;

  &__body {
    flex: 1 1 auto;
    min-width: 0;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: var(--ds-spacing-sm);
    flex-shrink: 0;
  }
}
</style>
